import { useMemo } from 'react';
import { ArdoqIcon, ArdoqIconCategory, getIconsByCategory } from '@ardoq/icons';
import { Select } from './Select';
import { ComponentIconOption } from './ComponentIconOption';
import { SelectProps } from '../types';
import { DEFAULT_ARDOQ_I18NLOCALE, type I18nLocale, t } from '@ardoq/i18n';

const getArdoqIconToIconOption =
  (ardoqIconCategory: ArdoqIconCategory, color?: string) =>
  ({ id, label }: ArdoqIcon) => ({
    label,
    value: id,
    leftContent: (
      <ComponentIconOption
        iconId={id}
        ardoqIconCategory={ardoqIconCategory}
        color={color}
      />
    ),
  });

const getIconOptionsByCategory = (
  ardoqIconCategory: ArdoqIconCategory,
  color?: string
) =>
  getIconsByCategory(ardoqIconCategory).map(
    getArdoqIconToIconOption(ardoqIconCategory, color)
  );

type ComponentIconSelectProps = Omit<SelectProps<string>, 'options'> & {
  color?: string;
};

export const ComponentIconSelect = ({
  color,
  i18nLocale = DEFAULT_ARDOQ_I18NLOCALE,
  ...selectProps
}: ComponentIconSelectProps) => {
  const options = useMemo(
    () => getComponentIconSelectOptions(i18nLocale, color),
    [i18nLocale, color]
  );
  return <Select {...selectProps} i18nLocale={i18nLocale} options={options} />;
};

const getComponentIconSelectOptions = (
  i18nLocale: I18nLocale,
  color?: string
) => [
  {
    label: t(i18nLocale, 'select:iconCategory.solutionIcons', 'Solution Icons'),
    options: getIconOptionsByCategory(ArdoqIconCategory.Solution, color),
  },
  {
    label: 'Font Awesome',
    options: getIconOptionsByCategory(ArdoqIconCategory.FontAwesome, color),
  },
  {
    label: 'ArchiMate',
    options: getIconOptionsByCategory(ArdoqIconCategory.ArchiMate, color),
  },
  {
    label: 'BPMN',
    options: getIconOptionsByCategory(ArdoqIconCategory.BPMN, color),
  },
  {
    label: 'EDGY',
    options: getIconOptionsByCategory(ArdoqIconCategory.EDGY, color),
  },
];
